import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      light: {
        primary: "#3458F5",
        info: "#E0E2FD",
        success: "#E0E2FD",
        colorbase:"#F2F4F8",
        colorblue400:"#E0E2FD",
      },
    },
  },
});